<template>
    <section class="flex-container my-4 p-2 rounded-md bg-cinza-desabilitado">
        <div class="text-vermelho-padrao flex items-center">
            <Icone :nome="'warning'" />
            <h3 class="font-semibold pl-2">Atenção</h3>
        </div>
        <div class="flex items-center gap-4 mb-2">
            <input type="checkbox" class="h-8 w-8 min-w-6 border-none border-preto-padrao cursor-pointer"
                name="cienteDispensaVistoria" id="cienteDispensaVistoria" v-model="cienteDispensaVistoria" @click="informarDispensa">
            <div class="text-justify leading-5">
                O cliente dispensa a vistoria e isenta o prestador(a) de serviço de qualquer dano ou avaria existente no
                veículo.
            </div>
        </div>
    </section>
</template>

<script>
import { defineComponent, ref } from 'vue';
import Icone from '@/components/Icone.vue';
import PropsComponentesConstant from '@/constants/PropsComponentesConstant';
import ComponentesService from '@/services/ComponentesService';

export default defineComponent({
    name: 'DispensarVistoria',
    components: {
        Icone
    },
    methods: {
        informarDispensa() {
            ComponentesService.salvarRespostaEstadoComponente(this.modulo, this.etapaComponente, this.identificador, !this.cienteDispensaVistoria)
        }
    },
    props: {
        ...PropsComponentesConstant.PROPS,
    },
    setup(props) {
        const cienteDispensaVistoria = ref(false)
        ComponentesService.salvarRespostaEstadoComponente(props.etapaComponente, props.identificador, cienteDispensaVistoria.value)
        return { cienteDispensaVistoria }
    }
});
</script>